<template>
  <div>
    <div v-for="(images, name) in previewImages" :key=name>
      <v-section-panel useBreak>
        <template v-slot:title>
          {{ images.name }}
        </template>
        <template v-slot:content>
          <v-container fluid>
            <v-row>
              <v-col cols=3 v-for="(image, index) in images.data" :key=index>
                <!-- 画像表示 -->
                <v-card
                  class="mx-auto"
                  max-width="300"
                  elevation="10"
                  @click.stop="showPhotoSwipe(name, index)"
                >
                  <v-img
                    class="white--text align-end"
                    :src="image.src"
                  >
                  </v-img>
                </v-card>
              </v-col>
            </v-row>
            <p v-if="images.name=='解答'" class="setting-alert">
              「解答」は画面上では２色で表示されていますが、実際には１色で印刷して納品されます。
            </p>
          </v-container>
        </template>
      </v-section-panel>
    </div>
    <v-photo-swipe
      :isOpen="isOpen"
      :items="selectedPreviewImage"
      :options="photoswipeOptions"
      @close="hidePhotoSwipe" />
  </div>
</template>

<script>
import VSectionPanel from '@/components/molecules/SectionPanel'
import VPhotoSwipe from '@/components/atoms/PhotoSwipe'

export default {
  components: {
    VSectionPanel,
    VPhotoSwipe,
  },

  props: {
    previewImages: {
      type: Object,
      default: () => {
        return {
          question: { name: '問題', data: [] },
          answerSheet: { name: '解答用紙', data: [] },
          answer: {name: '解答', data: [] },
        }
      }
    }
  },

  data: () => ({
    previewImageType: null,
    photoswipeOptions: {
      index: 0,
    },
    selectedPreviewImage: [],
    isOpen: false,
  }),

  methods: {
    showPhotoSwipe(type, index) {
      this.isOpen = true
      this.selectedPreviewImage = this.previewImages[type].data
      this.$set(this.photoswipeOptions, 'index', index)
    },
    hidePhotoSwipe(){
      this.isOpen = false
    },
  }
}
</script>

<style lang="stylus" scoped>
.setting-alert
  color:#FF0000;
  font-weight:bold;
</style>
